module.exports = __webpack_public_path__ + "img/know-5.79281ece.jpg";